<template>
  <div v-if="!readonly" class="row px-4">
    <div class="col-12 mb-2">
      <div class="step-notification step-notification--error" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="200">
        <p class="h4 main-sub-head font-weight-light text-center" v-html="$t('confirmation_instructions', { email: email })"></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    readonly: {
      type: Boolean,
      required: true
    },
    applicationData: {
      type: Object,
      required: true
    }
  },
  computed: {
    email() {
      if (this.applicationData.unconfirmed_email) {
        return this.applicationData.unconfirmed_email
      }
      return this.applicationData.email
    }
  }
}
</script>
